var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slide__body slide__body--transition"},[_c('div',{staticClass:"transition"},[_c('img',{attrs:{"src":`/static/images/island${_vm.island + 1}.png`,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }